import React from 'react';
import styles from '../../styles/AppBar.module.css';
import BackArrow from './BackArrow';

/**
 * AppBar component - displays a back arrow for in-app users
 * On click, sends 'back' message to React Native WebView
 * If form was successfully submitted, redirects to order details instead
 * Should only be rendered when in app mode (use conditional rendering)
 * @param {string|null} submittedOrderId - Order ID after successful submission, null otherwise
 */
const AppBar = ({ submittedOrderId = null }) => {
  const handleBackClick = () => {
    // Validate ReactNativeWebView is available
    if (!window?.ReactNativeWebView) {
      console.error('[AppBar] ReactNativeWebView not available - cannot send message');
      return;
    }

    if (submittedOrderId) {
      // Form was successfully submitted - redirect to order details
      try {
        const message = JSON.stringify({
          type: 'redirect_to_order',
          orderId: submittedOrderId,
        });
        window.ReactNativeWebView.postMessage(message);
      } catch (error) {
        console.error('[AppBar] Failed to send redirect message:', error);
        // Fallback to normal back navigation if redirect message fails
        try {
          window.ReactNativeWebView.postMessage('back');
        } catch (fallbackError) {
          console.error('[AppBar] Failed to send back message:', fallbackError);
        }
      }
    } else {
      // Normal back navigation
      try {
        window.ReactNativeWebView.postMessage('back');
      } catch (error) {
        console.error('[AppBar] Failed to send back message:', error);
      }
    }
  };

  return (
    <div className={styles.appBar}>
      <div className={styles.container}>
        <button
          className={styles.backButton}
          onClick={handleBackClick}
          aria-label="Go back"
        >
          <BackArrow className={styles.backIcon} />
        </button>
      </div>
    </div>
  );
};

export default AppBar;
